import script from "./AdminArticleRelations.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminArticleRelations.vue?vue&type=script&setup=true&lang=ts"

import "./AdminArticleRelations.vue?vue&type=style&index=0&id=9b72d8b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b72d8b0"]])

export default __exports__